// @ts-nocheck 3ebf1de9
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_page'],
      sections: [addPanel.sections.getSections().page.pageStyleSection],
    };
  },
};
